import { FlexBetween, FlexCol } from "./ui";
import { formatNumber } from "@/lib";
import { useTranslations } from "next-intl";

const InquiryCost = ({ cost }: { cost: number }) => {
  const t = useTranslations();
  return (
    <FlexCol
      gap={4}
      className="bg-primary-main w-full overflow-hidden rounded-2xl p-4 px-8 text-white"
    >
      <FlexBetween className="font-bold">
        <p className="text-xs md:text-sm xl:text-base">{t("wallet.cost")}</p>
        <FlexBetween gap={1} className="text-xs md:text-sm xl:text-base">
          <span>{formatNumber(cost)}</span>
          <span>{t("wallet.currency")}</span>
        </FlexBetween>
      </FlexBetween>
      {/* <p className="text-xs leading-5 lg:text-sm">{t("wallet.costDetails")}</p> */}
    </FlexCol>
  );
};

export default InquiryCost;
